(function () {
    'use strict';

    var bootstrapModule = angular.module('common.bootstrap', ['ui.bootstrap']);

    bootstrapModule.factory('bootstrap.dialog', ['$uibModal', '$templateCache', modalDialog]);

    function modalDialog($uibModal, $templateCache) {
        var service = {
            deleteDialog: deleteDialog,
            confirmationDialog: confirmationDialog
        };

        $templateCache.put('modalDialog.tpl.html',
            '<div>' +
            '    <div class="modal-header">' +
            '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="cancel()"><i class="fa fa-times"></i></button>' +
            '        <h4 class="modal-title"><i class="fa fa-pencil"></i>{{title}}</h4>' +
            '    </div>' +
            '    <div class="modal-body">' +
            '        <p>{{message}}</p>' +
            '    </div>' +
            '    <div class="modal-footer">' +
            '        <button class="btn btn-default" data-ng-show="cancelText.length > 1" data-ng-click="cancel()">{{cancelText}}</button>' +
            '        <button class="btn btn-success" data-ng-click="ok()">{{okText}}</button>' +
            '    </div>' +
            '</div>');

        return service;

        function deleteDialog(itemName) {
            var title = 'Conferma di Cancellazione';
            itemName = itemName || 'record';
            var msg = 'Eliminare ' + itemName + '?';

            return confirmationDialog(title, msg);
        }

        function confirmationDialog(title, msg, okText, cancelText) {

            var modalOptions = {
                templateUrl: 'modalDialog.tpl.html',
                controller: ModalInstance,
                keyboard: true,
                resolve: {
                    options: function () {
                        return {
                            title: title,
                            message: msg,
                            okText: okText,
                            cancelText: cancelText
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }
    }

    var ModalInstance = ['$scope', '$uibModalInstance', 'options',
        function ($scope, $uibModalInstance, options) {
            $scope.title = options.title || 'Title';
            $scope.message = options.message || '';
            $scope.okText = options.okText || 'OK';
            $scope.cancelText = options.cancelText || 'Annulla';
            $scope.ok = function () { $uibModalInstance.close('ok'); };
            $scope.cancel = function () { $uibModalInstance.dismiss('cancel'); };
        }];
})();